import React from 'react';
import { inject, observer } from 'mobx-react';
import { Badge, Button, Dropdown, Modal, List, message, notification } from 'antd';
import { ExclamationCircleTwoTone, DoubleRightOutlined } from '@ant-design/icons';
import {
  getMessageInfo,
  getUnreadMsgCount,
  setMsgReaded,
  getMessageUserInfo,
  getUrgencyMessage,
} from '@/common/js/api'
import { setFormatTime } from '@/common/utils/commonFunc'
import { URL } from '@/common/js/const'
import MsgWebSocket from '@/common/utils/msgWebSocket'
import CommonStore from '@/stores/commonStore';
import IconFont from '@/common/utils/iconfont'
import './index.less'

interface MessageListProps {
  CommonStore?: typeof CommonStore;
  collapsed: boolean;
}

@inject('CommonStore')
@observer
class MessageList extends React.Component<MessageListProps, any> {
  ws: WebSocket | undefined;
  constructor(props: MessageListProps) {
    super(props);
    this.state = {
      typeList: {
        1: 'knowledge',
        2: 'customerService',
        3: 'artificial'
      },
      messageList: [],
      messageCount: undefined,
      messageModalVisible: false,
      curMsg: {},
      msgCountDownTime: 0,
      msgModalBtn: '',
      unreadMessageCount: undefined, // 未读消息数
      showMessageId: [],
    };
  }

  componentDidMount() {
    this.setState({
      msgModalBtn: this.props.CommonStore!.curLocales.read
    })
    // 设置消息ws
    this.getMessageUserInfo()
  }

  getMessageUserInfo = () => {
    getMessageUserInfo().then((res) => {
      if (res.status === 0) {
        this.ws = MsgWebSocket({
          onMessage: (evt) => {
            if (evt.data) {
              const data = JSON.parse(evt.data)
              switch (data.msgType) {
                case 1:
                  this.setState({
                    unreadMessageCount: data.message
                  })
                  break
                case 2:
                case 3:
                  if (data.message && !this.props.CommonStore!.hideUrgentMsg) {
                    this.handleMsgClick(data.message)()
                    this.ws && this.ws.send(JSON.stringify({
                      msgType: 1,
                      timestamp: (new Date()).valueOf(),
                      message: ''
                    }))
                  }
                  break;
                default:
                  return
              }
            }
          },
          onError: () => {
            console.log('onError')
            this.getMessageInfo()
            this.getUrgencyMessage()
          }
        })
      }
    })
  }

  getMessageInfo = () => {
    getMessageInfo(this.props.CommonStore!.UserInfo.username).then((res: any) => {
      if (res.status === 0) {
        this.setState({
          messageList: res.data.msgs,
          messageCount: res.data.totalNum
        })
      } else {
        if (res.error) {
          message.error(res.error)
        }
      }
    })
    getUnreadMsgCount().then((res) => {
      if (res.status === 0) {
        this.setState({
          unreadMessageCount: res.data.count
        })
      }
    })
  }
  getTypeLabel = (type: number) => {
    return this.props.CommonStore!.curLocales[this.state.typeList[type]]
  }

  // 跳转老ark消息列表
  handleMsgMoreClick = () => {
    const Lang = this.props.CommonStore!.Cookies.lang || 'en-US'
    window.open(`${window.location.origin}/fe/ark_fe?lang=${Lang}${URL.msgList}`)
  }

  // 消息部分
  onMsgVisibleChange = (visible: boolean) => {
    if (visible) {
      this.getMessageInfo()
    }
  }

  getUrgencyMessage = () => {
    getUrgencyMessage(this.props.CommonStore!.UserInfo.username).then((res) => {
      if (res.status === 0) {
        let message = res.data.msg
        if (message !== null) {
          if (this.state.showMessageId.indexOf(message.id) < 0 && !this.props.CommonStore!.hideUrgentMsg) {
            this.setState({
              showMessageId: [...this.state.showMessageId, message.id]
            })
            this.openNotification(message)
          }
        }
      }
    })
  }

  openNotification = (message: { urgencyLevel: number; title?: string; content: string; isRead?: number; }) => {
    if (message.urgencyLevel === 1) {
      notification.open({
        message: message.title,
        description: <div dangerouslySetInnerHTML={{ __html: message.content }}></div>,
        duration: null,
        icon: <ExclamationCircleTwoTone twoToneColor='#ffca07' />,
        onClick: this.handleMsgClick(message),
        key: 'msg-notification'
      });
    } else if (message.urgencyLevel === 2) {
      this.handleMsgClick(message)()
    }

  }
  handleMsgClick = (item: { urgencyLevel: number; isRead?: number; }) => () => {
    this.setState({
      curMsg: item,
      messageModalVisible: true
    })
    if (item.urgencyLevel === 2 && item.isRead === 0) {
      this.countDownUrgentMsg()
    }
    if (item.urgencyLevel === 1) {
      notification.close('msg-notification')
    }
  }
  // 5s后可操作
  countDownUrgentMsg = async () => {
    const TEXTS = this.props.CommonStore!.curLocales || {}
    const second = 5
    for (var i = 0; i <= second; i++) {
      this.setState({
        msgCountDownTime: second - i,
        msgModalBtn: second - i > 0 ? `${TEXTS.countDownBegin}${second - i}${TEXTS.countDownEnd}` : TEXTS.read
      })
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  }
  // 设置msg已读
  hideMessageModal = () => {
    this.setState({
      messageModalVisible: false
    })
    if (this.state.curMsg.id && this.state.curMsg.isRead === 0) {
      setMsgReaded(this.state.curMsg.id).then(res => {
        if (res.status === 0) {
          this.state.messageList.forEach((msg: { id: number; }, index: number) => {
            if (msg.id === this.state.curMsg.id) {
              // eslint-disable-next-line
              this.state.messageList[index].isRead = 1
            }
          })
        }
      })
    }
  }

  render() {
    const TEXTS = this.props.CommonStore!.curLocales || {}
    return (
      <div className='message bottom-icon'>
        <Dropdown placement='topRight' trigger={['hover']} onVisibleChange={this.onMsgVisibleChange} overlayClassName={`MESSAGE_LIST ${this.props.collapsed ? '' : 'open'}`} overlay={(
          <div className='msg-list'>
            <List
              dataSource={this.state.messageList}
              renderItem={(item: { isRead: number; urgencyLevel: number; title: string; modifyLocalTime: number; content: string }) => (
                <List.Item className={`${item.isRead !== 0 ? 'readed' : ''}`}
                  onClick={this.handleMsgClick(item)}>
                  <h3>
                    {
                      item.urgencyLevel === 1 ? <ExclamationCircleTwoTone twoToneColor='#ffca07' /> : (
                        item.urgencyLevel === 2 ? <ExclamationCircleTwoTone twoToneColor='#C95D63' /> : <span></span>)
                    }
                    <span className='title' dangerouslySetInnerHTML={{ __html: item.title }} ></span>
                    <span className='date'>{setFormatTime(item.modifyLocalTime)}</span>
                  </h3>
                  <p dangerouslySetInnerHTML={{ __html: item.content }} className='message_preview'></p>
                </List.Item>
              )}
            >
              {this.state.messageCount > 5 ?
                <div className='message_more' onClick={this.handleMsgMoreClick}>
                  {TEXTS.more}
                  <DoubleRightOutlined style={{ color: '#629FF7', marginLeft: '5px' }} />
                </div> : null}
            </List>
          </div>

        )}>
          <span className='userinfo'>
            <Badge count={this.state.unreadMessageCount} overflowCount={99} size="small" offset={this.state.unreadMessageCount > 99 ? [10, 2] : [0, 0]} className="message-title"><IconFont type={'icon-Message'} /></Badge>
          </span>
        </Dropdown>
        {/* mesasge 弹窗展示 */}
        <Modal onCancel={this.hideMessageModal} key='MESSAGE_MODAL'
          className='message-detail'
          footer={[
            <Button type="primary" key='MESSAGE_MODAL_BTN'
              disabled={this.state.msgCountDownTime > 0 ? true : false}
              onClick={this.hideMessageModal}>
              {this.state.msgModalBtn}
            </Button>]}
          title={TEXTS.message}
          visible={this.state.messageModalVisible}
          maskClosable={false}
        >
          <h3 className='title'>
            {
              this.state.curMsg.urgencyLevel === 1 ? <ExclamationCircleTwoTone twoToneColor='#ffca07' /> : (
                this.state.curMsg.urgencyLevel === 2 ? <ExclamationCircleTwoTone twoToneColor='#C95D63' /> : <span></span>)
            }
            <span className='name' dangerouslySetInnerHTML={{ __html: this.state.curMsg.title }} ></span>
          </h3>
          <ul>
            <li>
              <span>{TEXTS.sendFrom}:</span>
              <span className='name'>{this.state.curMsg.sendFrom}</span>
            </li>
            <li>
              <span>{TEXTS.type}:</span>
              <span>{this.getTypeLabel(this.state.curMsg.type)}</span>
            </li>
            <li>
              <span>{TEXTS.time}:</span>
              <span>{setFormatTime(this.state.curMsg.modifyLocalTimeStr)}</span>
            </li>
            <li>
              <span>{TEXTS.sendTo}:</span>
              <span>{this.props.CommonStore!.UserInfo.username}</span>
            </li>
          </ul>
          <div className='MESSAGE_CONTENT' dangerouslySetInnerHTML={{ __html: this.state.curMsg.content }}></div>
        </Modal>
      </div>
    )
  }
}

export default MessageList
